import React from 'react'

const NotAvailableYet = () => {
  return (
    <div className="checkin-not-available">
      <div className="checkin-box">
        <h1>Online Check-in Not Yet Available</h1>
        <p>
          The Online Check-in is not yet available for this reservation.
          Please check again no earlier than <strong>7 days before your scheduled arrival date</strong>.
        </p>
        <p className="secondary-msg">
          Click the same link again once you're within the eligible time window.
        </p>
      </div>
    </div>

  )
}

export default NotAvailableYet